import Vue from "vue";
import VueI18n from "vue-i18n";
import VueCookies from "vue-cookies";

const messages = {
  en: {
    correctDate: "The end date must greater than start date",
    exportPackingList: "Export Packing List",
    login: "Login",
    register: "Register",
    search: "Search",
    reviewList: "Review",
    questionList: "Questions",
    productList: "Product",
    orderList: "Order",
    financeList: "Finance",
    returnList: "Return Request",
    bannerList: "Banner List",
    promotionList: "Promotion List",
    aboutus: "About Us",
    settings: "Settings",
    campaignList: "Campaign List",
    faq: "FAQ",
    chat: "Chat",
    new: "New",
    you: "you",
    wellcomeToChat: "Welcome to Chat",
    sendChat: "Chat",
    sendPhoto: "Send Photo",
    yesterday: "Yesterday",
    startChatWith: "Start chat with",
    chatNotFound: "Chat Not Found",
    orderNo: "Order No.",
    filter: "FILTER",
    reviewStatus: "Review Status",
    startDate: "Start Date",
    endDate: "End Date",
    search: "Search",
    page: "page",
    products: "Product",
    review: "Review",
    dateTime: "Date/Time",
    status: "Status",
    reviewDetails: "Review Details",
    reply: "Reply",
    cancel: "Cancel",
    lastUpdated: "Last update",
    replyReview: "Reply Review",
    notifyViaEmail: "Notify to buyer via email",
    product: "Product",
    question: "Question",
    review: "Review",
    order: "Order",
    finance: "Finance",
    return: "Return",
    profile: "Profile",
    logout: "Logout",
    clear: "Clear",
    logoutMsg: "Are you sure you want to log out ?",
    yes: "Yes",
    no: "No",
    productName: "Product Name",
    questionStatus: "Question Status",
    questionBy: "Question by",
    questionDetails: "Question Details",
    answer: "Answer",
    ans: "Answer",
    verifyStatus: "Verify Status",
    noVerify: "Not Verified",
    verified: "Verified",
    customerName: "Customer Name",
    pendingMethod: "Pending Method",
    paymentChannel: "Payment Channel",
    amount: "Retail Price",
    orderStatus: "Order Status",
    selectDate: "Please select date",
    selectPayment: "Please select payment channel",
    cancelOrder: "Cancel Order",
    buyerInfo: "Buyer Info",
    name: "Name",
    tel: "Telephone",
    email: "Email",
    tier: "Tier",
    shippingAddress: "Shipping Address",
    receiptAddress: "Receipt Address",
    print: "Print",
    thumbnail: "Thumbnail",
    qty: "Quantity",
    total: "Total",
    discount: "Discount",
    affiliateCom: "Affiliate commission",
    getfinFee: "Brand fee",
    getfinService: "Brand service fees",
    shippingFee: "Shipping fee",
    grandtotal: "Grand total",
    noteCustomer: "Note to customer",
    sendSubmit: "Submit",
    updateBy: "Update by",
    noData: "No matching records found",
    returnNo: "Return No.",
    customerDetails: "Customer Details",
    purchaseTime: "Date/Time purchase",
    returnTime: "Date/Time return",
    details: "Details",
    releaseDate: "Release Date",
    requestDetails: "Request details",
    sendBackDetails: "Send back details",
    deliverySlip: "Delivery slip",
    returnReason: "Return Reason",
    imgProductList: "Image of product",
    shippingMethod: "Shipping Method",
    trackingNo: "Tracking No.",
    productStatus: "Product Status",
    available: "Available",
    visible: "Visible",
    displayStatus: "Display status",
    price: "Price",
    general: "General",
    useSameLang: "Use same language",
    category: "Category",
    desc: "Description",
    productType: "Product Type",
    image: "Images",
    supportImg: "Support only .jpg, .png for image (Maximum 10 MB)",
    delivery: "Delivery",
    weightProduct: "Package Weight (g)",
    lengthProduct: "Dimensions Length (cm)",
    widthProduct: "Dimensions Width (cm)",
    heightProduct: "Dimensions Height (cm)",
    displayStatusSwh: "Display Status",
    active: "Active",
    inactive: "Inactive",
    productDetails: "Product Details",
    inventory: "Inventory",
    userReview: "User Review",
    max: "Maximum",
    availability: "Availability",
    inStock: "In Stock",
    onHold: "On Hold",
    availableStock: "Available",
    answerStatus: "Answer Status",
    overall: "Overall",
    star: "stars",
    reviewBy: "Review by",
    rating: "Rating",
    sellerLogo: "Brand Logo",
    shipping: "Shipping",
    invoiceNum: "Invoice No.",
    sellerAccount: "Brand account",
    businessInformation: "Business information",
    bankAccount: "Bank account",
    warehouseAddress: "Warehouse address",
    sellerId: "Brand ID",
    sellerName: "First name",
    sellerLastname: "Last name",
    emailAddress: "Email address",
    phoneNumber: "Phone number",
    displayNameTH: "Store name (TH)",
    displayNameEN: "Store name (EN)",
    companyName: "Legal name / Company name",
    houseNo: "House No.",
    building: "Building / Village",
    road: "Road / Alley",
    province: "Province",
    district: "District",
    subdistrict: "Sub-district",
    businnerRegisNum: "Business registration No.",
    businessDocument: "Business information document",
    taxDocument: "Tax registration document",
    companyProvince: "Company province",
    vatEnterprice: "VAT Enterprise",
    accountName: "Account name",
    accountNumber: "Account No.",
    bank: "Bank",
    bankDocument: "Bank information document",
    warehouseName: "Warehouse name",
    uploadLogo: "Please upload your logo",
    shippingList: "Shipping list",
    myShipping: "My shipping",
    searchShipping: "Search shipping name",
    invoicePrefix: "Invoice prefix",
    accountStatement: "Account statement",
    orderOverview: "Order overview",
    transactionOverview: "Transaction overview",
    earning: "Earning",
    amtToRecieve: "Amount to be recieved (THB)",
    paymentMethod: "Payment method",
    statementStatus: "Statement status",
    edit: "Edit ",
    open: "Open",
    statementNumber: "Statement Number",
    statementNo: "Statement No",
    orderDate: "Order Date",
    comission: "Commission",
    paymentFee: "Payment Fee",
    customer: "Customer",
    shippingCost: "Shipping Cost",
    promotion: "Promotions",
    statementPeriod: "Statement Period",
    payoutStatus: "Payout Status",
    payoutAmt: "Payout Amount",
    filterBy: "Filter By",
    transactionNo: "Transaction No.",
    statement: "Statement",
    openBalance: "Subtotal (VAT included)",
    itemPriceCredit: "Item price credit",
    affiliateFee: "Affiliate Fee",
    subTotal: "Subtotal (THB)",
    closeBalance: "Closing Balance (THB)",
    paidByCus: "Paid by customer",
    paidBySeller: "Paid by seller",
    paid: "Paid",
    totalOrder: "Total orders (all status)",
    deliveredOrder: "Delivered",
    deliveredOrderFail: "Delivery Failed",
    returnOrder: "Returned",
    selectCategoryRequired: "Please select at least one category",
    required: "This field can’t be empty",
    enterAtLeast: "Please enter at least",
    chars: "characters",
    emailError: "Please enter your email address (e.g. email@example.com)",
    numOnly: "Please enter number only",
    noMoreThan: "Please enter no more than",
    passNotMatch: "Passwords must match",
    charNotMatch: "Please enter English characters only.",
    minValueError: "The value must greater than ",
    selectImgError: "Please select image for this option",
    alreadyPack: "Call to ship",
    printCoverPage: "Print cover page",
    onceTheSelectedItemCoverSheetIsPrinted:
      "Once the selected item cover sheet is printed, it will be confirmed and called for delivery to pick up the selected item.",
    pleasePrepareTheProduct: "Please prepare the product.",
    theDateAndTimeReceivingTheProductDependingOnTheServiceProvider:
      "The date and time of receiving the product depending on the service provider",
    close: "Close",
    delete: "Delete",
    doYouWantToDelete: "Do you want to delete",
    yesOrNo: "",
    confirmDelete: "Confirm Delete",
    article: "Feeds",
    createDate: "Last Update",
    createArticle: "Create",
    articleStatus: "Display status",
    articleName: "Feed Name",
    articleDesc: "Short description",
    sortOrder: "Sort Order",
    urlKey: "URL Key",
    cover: "Cover",
    displayOnProduct: "Display on product",
    sold: "Sold (Price)",
    pleaseUpload: "Please choose file to upload",
    displayOnSelected: "Display only selected",
    selectCategory: "Please select category",
    enterAtLeastOption: "Please enter option at least 1 option.",
    fillThisForm: "Please fill up this form.",
    increase: "Increase",
    decrease: "Decrease",
    adjust: "Adjust",
    variation: "Variation",
    optionName: "Option name",
    options: "Options",
    createNewOptions: "Create new option",
    stock: "Stock",
    saveAndPublish: "save and publish",
    saveDraft: "save as draft",
    check: "Edit",
    outOfStock: "Out Of Stock",
    lowStock: "Low Stock",
    create: "Create",
    importData: "Import Data",
    exportData: "Export Data",
    downloadTemplate: "Download Blank template",
    inOutwards: "Inwards/Outwards",
    closingBalance: "Closing Balance",
    refNo: "Reference No.",
    unit: "Unit",
    combinationList: "Pricing and Stock",
    answer: "Answer",
    waitForAns: "Wait for answer",
    productSelected: "Product(s) Selected",
    add: "Add ",
    note: "Note",
    stockLog: "Stock Log",
    defaultImg: "Default images",
    fileNotSupport: "This file is not supported",
    fileIsTooLarge: "This file is too large",
    supportFile: "*Please upload only file .png, .jpg and .pdf less than 50 MB",
    view: "View",
    pleaseWait: "Please wait",
    action: "Action",
    simpleProduct: "Simple product",
    configProduct: "Configuration product",
    action: "Action",
    save: "Save",
    saveAndExit: "Save and exit",
    selectProvince: "Please select Province",
    selectDistrict: "Please select District",
    selectSubDistrict: "Please select Sub-district",
    selectBank: "Please select Bank",
    approve: "Approve",
    reject: "Reject",
    inprogress: "In progress",
    replyRequest: "Note for this request",
    returnDetails: "Return Details",
    campaign: "Campaign",
    campaignName: "Campaign name",
    seller: "Seller",
    regisCloseIn: "Registration close in",
    campaignPeriod: "Campaign live period",
    campaignDetails: "Campaign Details",
    currentPrice: "Current Price",
    campaignPrice: "Campaign Price",
    stockToBuy: "Stock to buy",
    salePrice: "Strike Price",
    bankName: "Bank Name",
    bankAccountNo: "Bank Account No.",
    bankAccountName: "Bank Account Name",
    defaultImgError: "Please select at least one images",
    currentStock: "Current Stock",
    remainStock: "Remaining Stock",
    omiseTotal: "Omise Fee",
    omiseVat: "Omise Vat.",
    omiseCharge: "Omise Charge",
    requestApprove: "Request Approve",
    shippingSubsidize: "Shipping Subsidize",
    attention: "Attention",
    noteFromAdmin: "Note from Admin",
    partner: "Brand",
    seller: "Seller",
    generalSellerAccountError: "Please enter brand account infomation",
    generalBusinessProfileError: "Please enter business infomation",
    generalBankAccountError: "Please enter bank account infomation",
    generalWarehouseAddressError: "Please enter warehouse address",
    invoiceError: "Please enter invoice prefix",
    logoError: "Please enter brand logo",
    shippingError: "Please enter shipping",
    oldToNew: "Oldest - Latest",
    newToOld: "Latest - Oldest",
    warningLogs:
      "Your account has not been verified causing you are not able to withdraw from your bank account. Please allow 1-3 business days to wait for verification. We apologize for inconvenience. If you have any questions, please contact Administrator.",
    day: "day",
    addProductToCampaign: "Add product to campaign",
    sold: "Sold",
    outOfStock: "Out of stock",
    waitForPay: "Wait for pay",
    waitForShip: "Wait for Ship",
    waitForConfirm: "Wait for confirm",
    returnRequest: "Return request",
    codReject: "COD Reject",
    revenue: "Revenue",
    view: "View",
    avgOrder: "Average of order",
    upcomingCampaign: "Upcoming campaign",
    sellerDb: "Seller",
    openDb: "Open",
    returnProduct: "Return Product",
    selectOrderError: "Please select order",
    avaliableCampaign: "Avaliable Campaign",
    registeredCampaign: "Registered Campaign",
    join: "Join",
    basicInfo: "Basic Info",
    registrationEnd: "Registration ends in",
    joinNow: "Join now",
    joined: "Joined",
    sellerJoined: "Sellers are join",
    productCount: "Product(s)",
    start: "Start",
    end: "End",
    display: "Display",
    notdisplay: "Not Display",
    productPrice: "Price",
    noCampaign: "No data found",
    notJoin: "Not joined yet",
    gpFee: "GP fee (VAT 7%)",
    grandtotalWithoutGP: "Grand total without GP fee",
    omiseFee: "Omise fee",
    noDataCategory: "No data found",
    location: "Location",
    seeBookBank: "See book bank details",
    sendMsg: "Send message",
    noMoreThanPrice: "Campaign Price must not more than price",
    totalOrder: "Total",
    gpOrder: "GP fee",
    vatGp: "VAT 7% (GP) ",
    totalWithGp: "Raw Price",
    shippingOrder: "Shipping fee",
    hello: "Hello! How can I help you?",
    dbProductOverview: "Product Overview",
    dbRevenueProduct: "Revenue Product",
    dbPerformance: "Performance",
    dbCampaign: "Campaign",
    dbProductPerformance: "Product Performance",
    resendOrder: "Resend Order",
    todayPerformance: "Today Performance",
    dbTotalSale: "Total Sale",
    dbTotalOrder: "Total Order",
    dbTotalPerClick: "Total Order Per Click",
    dbTotalSalePerCustomer: "Total Sale Per Customer",
    dbOverview: "Overview",
    week: "Week",
    month: "Month",
    year: "Year",
    dbCustomerDetails: "Customer Details",
    male: "Male",
    female: "Female",
    genderOther: "N/A",
    dbCusByProvince: "Customer grouping by province",
    provinceName: "Province Name",
    topTenBestSellerBaht: "Top 10 Best seller (THB)",
    topTenBestSellerUnit: "Top 10 Best seller (Unit)",
    topTenProfit: "Top 10 Profit (THB)",
    topTenShare: "Top 10 Share",
    resend: "Resend Order",
    sent: "Sent",
    shareCount: "Share Count",
    clickCount: "Click Count",
    conversion: "Conversion",
    viewCount: "View Count",
    cashBack: "Cash Back",
    fee: "Fee",
    totalShare: "Total Share (Product/Article)",
    totalJoinCampaign: "Total of join campaign",
    totalShareProduct: "Total Share Product",
    totalOrderDb: "Total Order",
    totalProductJoinCampaign: "Total of Product Join Campaign",
    totalProduct: "Total Product",
    totalProductShare: "Total Share Product",
    totalProductChannel: "Total Product Channel",
    totalChashback: "Total Cash Back",
    revenuePorductChanel: "Revenue Product Channel",
    productListDb: "Product List",
    campaignListDb: "Campaign List",
    revenueCampaign: "Campaign Revenue",
    totalOrderCampaign: "Total Order of Join Campaign",
    top1: "Top 1",
    top2: "Top 2",
    top3: "Top 3",
    bannerName: "Banner name",
    exLink: "External Link",
    bannerImgDesktop: "Banner Thumbnail (Desktop)",
    bannerImgMobile: "Banner Thumbnail (Mobile)",
    returned: "Returned",
    textValidatePassword:
      "Password must contain letters a-z and 1-9. It should be at least 6 characters",
    noQuestion: "No question found",
    welcome: "Welcome to Brand Center",
    login: "Login",
    password: "Password",
    conpassword: "Confirm Password",
    forgetPass: "Forget password",
    resetPass: "Reset password",
    thisLinkAlreadyUsed: "This link already used",
    becomePartner: "Become a Brand",
    requestOtp: "Request OTP",
    receiveOtp: "You will recieve an OTP in 3 min.",
    shopName: "Store name",
    iaccept: "I accept",
    termandcon: "Terms & Conditions",
    and: "and",
    privacy: "Privacy policy",
    submit: "Submit",
    alreadyHasAcc: "Already have an account",
    waitApprove:
      "Your account has been waiting for approve from Administrator. Please allow 1-3 business days to wait for verification. You can create products as usual, but your products will not be able to sell until receiving account confirmation from the Administrator.",
    above: "Above",
    all: "All",
    youCanResendIn: "You can resend in",
    submitOtp: "Submit OTP",
    enterOTP: "Enter OTP",
    changeTelephoneNumber: "Change Telephone Number",
    referenceCode: "Ref",
    dashboard: "Dashboard",
    omiseWithdraw: "Omise Withdraw Fee",
    paidByPartner: "Paid by brand",
    bookBank: "Book bank",
    subTotalOrder: "Sub Total (VAT 7%)",
    shippingDetails: "Shipping Details",
    trackNo: "Tracking No.",
    sentby: "Shipping by",
    shippingStatus: "Shipping Status",
    nofaq: "Question not found, Please contact Administator",
    telError: "Please enter your telephone number",
    otpError: "Invalid OTP. Please enter valid OTP",
    requestOtp: "Request OTP",
    bannerImgRequire:
      "Please upload only file .png, .jpg with 16:9 image and .mp4 less than 50 MB",
    bannerImgRequire1_1:
      "Please upload only file .png, .jpg with 1:1 image and .mp4 less than 50 MB",
    bannerImgRequire4_3:
      "Please upload only file .png, .jpg with 4:3 image and .mp4 less than 50 MB",
    bannerImgRequire10_2:
      "Please upload only file .png, .jpg with 10:2 image and .mp4 less than 50 MB",
    bannerImgRequire10_4:
      "Please upload only file .png, .jpg with 10:4 image and .mp4 less than 50 MB",
    feedImgRequire:
      "Please upload only file .png, .jpg with 4:3 image less than 10 MB",
    withdraw: "Withdraw",
    withdrawreq: "Do you want to withdraw ",
    from: " from bank account ",
    withdrawreq2: "?",
    confirmWithdraw: "Confirm withdraw",
    serviceGp: "GP",
    costCod: "COD",
    creditFee: "Credit fee (3.6%)",
    withdrawFee: "Withdraw fee (2% Min. 30 THB)",
    otherFee: "Other fee",
    addLinePartner: "Please add our official line for contact our Brand team.",
    orClick: "or Click",
    importprodata: "Import Product Data",
    exportprodata: "Export Product Data",
    loadtemplate: "Download Product Template",
    importfile: "File",
    import: "Import",
    excelOnly: "*Please upload only file .xlsx less than 10 MB",
    ofRawPrice: "of product price.",
    minProductGP: "The GP value must be greater than or equal to",
    outstandingBalance: "Outstanding Balance",
    anonymousReturn: "Anonymous Return Request",
    chooseFile: "Choose File",
    totalSales: "Total sales",
    totalDiscount: "Total discount",
    salesAfterDiscount: "Sales after discount",
    expenses: "Expenses",
    salesFee: "Sales Fee Seller",
    salesFeeThroughSystem: "Sales fee through the system Brand",
    paymentFees: "Payment fees",
    shippingAndCODFees: "Shipping and delivery fees",
    shippingFees: "Shipping fees",
    CODFees: "Delivery fees",
    netIncome: "Net income",
    downloadInvoice: "Download invoice",
    waitingForPayment: "Waiting for payment",
    withdrawalAndTransferFees: "Withdrawal and Transfer Fees",
    seeMore: "See more",
    showOrderDetails: "Show order details",
    viewInvoiceDetails: "View invoice details",
    invoice: "Invoice",
    downloadDoc: "Download",
    amountOverdue: "Amount overdue",
    downloadTaxInvoice: "Download the tax invoice",
    downloadList: "Download list",
    withholdingTax: "Withholding tax",
    paymentTransactionFee: "Payment transaction fee",
    totalService: "Total service",
    totalServiceVat: "Total service (VAT included)",
    totalSalesFee: "Total sales fee (GP)",
    waitingOrderComplete: "Waiting for the order to complete",
    homePage: "Home",
    campaignInfo: "Campaign Info",
    campaignProductList: "Campaign Product List",
    orderDetails: "Order Details",
    resendOrderDetails: "Resend Order Details",
    returnOverview: "Return Overview",
    articleList: "Article List",
    articleDetails: "Article Details",
    FAQList: "FAQ List",
    bannerDetails: "Banner Details",
    bannerPromotionList: "Banner Promotion List",
    bannerPromotionDetails: "Banner Promotion Details",
    Page404: "404",
    page500: "500",
    VATIncluded: "VAT included",
    VATNotIncluded: "VAT not included",
    netAmount: "Net amount",
    incomeAfterDiscount: "Income after discount",
    textValidateUrlkey:
      "URL Key contain letters ก-ฮ, a-z, 1-9, or special characters - and _",
    productPriceError: "value must be greater than",
    maxSalestockError: "Stock to buy must be less than or equal to stock.",
    TotalAfterDeductionExpenses: "Total after deduction of expenses",
    transferAmount: "Transfer amount",
    platformAdministrationFee: "Platform administration fee",
    consentProductToLive: "Consent to bring the product to Live",
    agree: "Agree",
    doNotAgree: "Do not agree",
    textClickConfirmAgree:
      'By clicking "Confirm", you agree to the terms of use according to the usage policy.',
    limitChangeGP: "You have exceeded the required number of GP replacements",
    pleaseSelect: "Please select ",
    aboutStore: "About the store",
    storeDesc: "Store description (Bio)",
    gpWarningText:
      "Note: GP can be edited once a month and new GP changes will take effect every 1st day of the following month only.",
    editProductGP: "EDIT PRODUCT GP",
    cancelGP: "Cancel",
    submitGP: "Submit",
    legalEntity: "Legal entity",
    sellerGetfinFee: "Seller Brand fee",
    loading: "Loading",
    downloadSellerFeeInvoice: "Download seller's fee tax invoice",
    downloadInvoiceOther: "Download tax invoices for other expenses",
    descUrlKey: "URL Key can be edited in English and must not contain spaces.",
    textSystemMaintenance1: "Sorry for the inconvenience",
    textSystemMaintenance2:
      "Brand would like to inform you that the website is temporarily closed for renovation",
    textSystemMaintenance3:
      "To develop the system and increase efficiency better",
    textSystemMaintenanceOnDate: "On",
    textSystemMaintenanceOnTime1: " ",
    textSystemMaintenanceOnTime2: " ",

    lastStatus: "Last Status",
    detailsRequest: "Details of the request",
    detailAddress: "Detail Address",
    detailReceipt: "Detail Receipt",
    moneyTransferDetails: "Money Transfer Details",
    imgReturnIlustration: "Image Return Ilustration",
    saveReplyRequest: "Additional notes for this",
    date: "Date",
    time: "Time",
    returnApproval: "Return Approval",
    refuseReturn: "Refuse to Return",
    returnDetails: "Return details",
    returnIllustration: "Return illustration",
    transport: "Transport",
    tracking: "Tracking",
    bankAccount: "BankAccount",
    bankAccountNumber: "Bank Account Number",
    bankAccountName: "Bank Account Name",
    proofOfTransfer: "Proof of Transfer",
    viewDetail: "View Detail",
    transferAmount: "Transfer amount",
    lastUpdate: "Last Update",
    confirmation: "Confirmation",
    areYouSureYouWantToConfirmReceiptOfTheProduct:
      "Are you sure you want to confirm receipt of the product?",
    viewDetailsOfProofOfTransfer: "View details of proof of transfer",
    paymentInfo: "Payment info",
    warningImportProduct: "Please check the file before uploading the product.",
    msgAlertComfirmReturn:
      "กรุณาตรวจสอบสินค้าที่ได้รับคืนมาจากการส่งของผู้ซื้อ ว่าสินค้าไม่ได้รับการใช้งานการเสียหายจากการขนส่ง หรือ การเสียหายจากการใช้งาน หากตรวจสอบเรียบร้อยแล้วต้อง การยืนยันการคืนสินค้า สามารถดำเนินการโอนเงินไปยังผู้ซื้อได้ทันที",
    msgComfirmReturn: "คุณแน่ใจหรือไม่ว่าต้องการยืนยันการได้รับสินค้า",
    msgConfirmReceiptReturn: "ยืนยันการได้รับสินค้า",
    msgAlertComfirmRejectReturn:
      "เมื่อคุณปฎิเสธการรับสินค้าคืนแล้วจะถือเป็นการสิ้นสุดกระบวนการคืนสินค้าของระบบ คุณจะต้องดำเนินการติดตามการชดใช้จากผู้ซื้อด้วยตนเองเท้านั้น คุณต้องการปฎิเสธการรับสินค้า ที่ได้รับการส่งคืนจากผู้ซื้อ ด้วยเหตุผลใดโปรดระบุ",
    msgComfirmRejectReturn: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธการรับสินค้า",
    msgConfirmReceiptRejectReturn: "ยืนยันการปฏิเสธการรับ",
    requireTinyUploadImg: "Maximun image size 5 MB",
    uploadFail: "Upload fail",
    transferMoney: "Transfer money",
    ourPartner: "Our brand",
    findPartner: "Find brand",
    partnerNotFound: "Brand not found",
    additionalCostFromTransportation: "Additional cost from transportation",
    shippingTypeName: "Shipping by",
    ShippingType: "Shipping type",
    BuyingMethod: "Order channel",
    importTrackingFile: "Import tracking File",
    ExportOrder: "Export Order",
    downloadTemplate1: "Download Template",
    uploadTrackingFile: "Upload tracking file",
    chooseShippingName: "Choose shipping name",
    selectShippingName: "Please select shipping name",

    discountFromGetfin: "Discount from Brand",
    discountFromSeller: "Discount from partner",

    updateShipping: "Update shipping",
    moreDetail: "More details",
    noteForOwnfleet:
      "for delivery by brand The brand must be responsible for all shipping costs in all cases.",
    headerOwnShipping: "Support delivery by brand",
    iagree: "Accept",
  },
  th: {
    correctDate: "วันสิ้นสุดต้องมากกว่าวันเริ่มต้น",
    exportPackingList: "ดาวน์โหลดรายการจัดส่ง",
    login: "เข้าสู่ระบบ",
    register: "สมัครสมาชิก",
    search: "ค้นหา",
    reviewList: "รายการรีวิว",
    questionList: "รายการคำถาม",
    productList: "รายการสินค้า",
    orderList: "รายการคำสั่งซื้อ",
    financeList: "รายการเกี่ยวกับการเงิน",
    returnList: "รายการคืนสินค้า",
    campaignList: "รายการแคมเปญ",
    bannerList: "รายการแบนเนอร์",
    promotionList: "รายการโปรโมชั่น",
    faq: "คำถามที่พบบ่อย",
    settings: "การตั้งค่า",
    aboutus: "เกี่ยวกับเรา",
    chat: "แชท",
    new: "ใหม่",
    you: "คุณ",
    wellcomeToChat: "ยินดีต้อนรับเข้าสู่หน้าแชท",
    sendChat: "ส่งข้อความ",
    sendPhoto: "ส่งรูปภาพ",
    yesterday: "เมื่อวาน",
    startChatWith: "เริ่มแชทกับ",
    chatNotFound: "ไม่พบรายการแชท",
    orderNo: "เลขที่คำสั่งซื้อ",
    filter: "ค้นหาแบบละเอียด",
    reviewStatus: "สถานะของรีวิว",
    startDate: "วันเริ่มต้น",
    endDate: "วันสิ้นสุด",
    search: "ค้นหา",
    page: "หน้า",
    products: "สินค้า",
    review: "รีวิว",
    dateTime: "วันที่ทำรายการ",
    status: "สถานะ",
    reviewDetails: "รายละเอียดรีวิว",
    reply: "ตอบกลับ",
    cancel: "ย้อนกลับ",
    lastUpdated: "วันที่อัพเดทล่าสุด",
    replyReview: "ตอบกลับรีวิว",
    notifyViaEmail: "แจ้งเตือนผู้ซื้อผ่านอีเมล",
    product: "รายการสินค้า",
    question: "รายการคำถาม",
    review: "รายการรีวิว",
    order: "รายการสั่งซื้อ",
    finance: "รายการการเงิน",
    return: "รายการคืนสินค้า",
    profile: "ข้อมูลส่วนตัว",
    logout: "ออกจากระบบ",
    clear: "ลบทั้งหมด",
    logoutMsg: "คุณแน่ใจหรือไม่ว่าคุณต้องการออกจากระบบ?",
    yes: "ใช่",
    no: "ไม่",
    productName: "ชื่อสินค้า",
    questionStatus: "สถานะคำถาม",
    questionBy: "คำถามโดย",
    questionDetails: "รายละเอียดคำถาม",
    answer: "คำตอบ",
    ans: "ตอบ",
    verifyStatus: "สถานะยืนยัน",
    noVerify: "ยังไม่ได้ยืนยัน",
    verified: "ยืนยันแล้ว",
    customerName: "ผู้ซื้อ",
    pendingMethod: "ช่องทางการชำระเงิน",
    paymentChannel: "ช่องทางการชำระเงิน",
    amount: "จำนวนเงิน",
    orderStatus: "สถานะรายการสั่งซื้อ",
    selectDate: "กรุณาเลือกวันที่",
    selectPayment: "กรุณาเลือกช่องทางการชำระเงิน",
    cancelOrder: "ยกเลิกรายการ",
    buyerInfo: "ข้อมูลผู้ซื้อ",
    name: "ชื่อ",
    tel: "เบอร์โทรศัพท์",
    email: "อีเมล",
    tier: "ระดับ",
    shippingAddress: "ที่อยู่จัดส่ง",
    receiptAddress: "ที่อยู่สำหรับส่งใบเสร็จ",
    print: "พิมพ์",
    thumbnail: "รูปภาพ",
    qty: "จำนวน",
    total: "รวม",
    discount: "ส่วนลด",
    affiliateCom: "คอมมิชชั่นตัวแทน",
    getfinFee: "ค่าธรรมเนียม Brand",
    shippingFee: "ค่าจัดส่ง",
    grandtotal: "รวมสุทธิ",
    noteCustomer: "ข้อความถึงลูกค้า",
    sendSubmit: "ส่ง",
    updateBy: "อัพเดทโดย",
    noData: "ไม่พบข้อมูล",
    returnNo: "เลขที่คำขอคืนสินค้า",
    customerDetails: "ผู้ซื้อ",
    purchaseTime: "วันที่ซื้อ",
    returnTime: "วันที่คืนสินค้า",
    details: "รายละเอียด",
    releaseDate: "วันที่วางจำหน่าย",
    requestDetails: "รายละเอียดคำขอ",
    sendBackDetails: "รายละเอียดคำขอคืนสินค้า",
    deliverySlip: "รูปสลิป",
    returnReason: "เหตุผลในการคืนสินค้า",
    imgProductList: "รูปสินค้า",
    shippingMethod: "รูปแบบการส่ง",
    trackingNo: "เลขพัสดุ",
    productStatus: "สถานะสินค้า",
    available: "สต๊อก",
    visible: "แสดงผล",
    displayStatus: "ปิด/เปิดแสดงผล",
    price: "ราคา",
    general: "ข้อมูลทั่วไป",
    useSameLang: "ใช้เหมือนกันทุกภาษา",
    category: "หมวดหมู่",
    desc: "คำอธิบาย",
    productType: "ประเภทสินค้า",
    image: "รูปภาพ",
    supportImg: "รับรองสกุลไฟล์ .jpg, .png เท่านั้น (สูงสุด 10 MB)",
    delivery: "การขนส่ง",
    weightProduct: "น้ำหนัก (ก.)",
    lengthProduct: "ความยาว (ซม.)",
    widthProduct: "ความกว้าง (ซม.)",
    heightProduct: "ความสูง (ซม.)",
    displayStatusSwh: "สถานะการแสดงผล",
    active: "ใช้งาน",
    inactive: "ไม่ใช้งาน",
    productDetails: "รายละเอียดสินค้า",
    inventory: "คลังสินค้า",
    userReview: "รีวิวสินค้า",
    max: "สูงสุด",
    availability: "การใช้งาน",
    inStock: "สต๊อก",
    onHold: "รอชำระเงิน",
    availableStock: "พร้อมใช้งาน",
    answerStatus: "สถานะคำตอบ",
    overall: "ภาพรวม",
    star: "ดาว",
    reviewBy: "รีวิวโดย",
    rating: "คะแนน",
    sellerLogo: "โลโก้ของเรา",
    shipping: "การจัดส่ง",
    invoiceNum: "เลขที่คำสั่งซื้อ",
    sellerAccount: "บัญชีแบรนด์",
    businessInformation: "ข้อมูลธุรกิจ",
    bankAccount: "บัญชีธนาคาร",
    warehouseAddress: "ที่อยู่คลังสินค้า",
    sellerId: "เลขที่ผู้ขาย",
    sellerName: "ชื่อ",
    sellerLastname: "นามสกุล",
    emailAddress: "อีเมล",
    phoneNumber: "เบอร์โทรศัพท์",
    displayNameTH: "ชื่อร้านค้า (TH)",
    displayNameEN: "ชื่อร้านค้า (EN)",
    companyName: "ชื่อจดทะเบียน / ชื่อบริษัท",
    houseNo: "ที่อยู่",
    building: "ตึก / หมู่บ้าน",
    road: "ถนน / ซอย",
    province: "จังหวัด",
    district: "อำเภอ",
    subdistrict: "ตำบล",
    businnerRegisNum: "เลขทะเบียนนิติบุคคล",
    businessDocument: "หนังสือรับรองบริษัท",
    taxDocument: "ใบทะเบียนภาษีมูลค่าเพิ่ม ภ.พ. 20",
    companyProvince: "จังหวัดที่ตั้งของบริษัท",
    vatEnterprice: "บริษัทจดทะเบียนภาษีมูลค่าเพิ่ม (VAT)",
    accountName: "ชื่อบัญชี",
    accountNumber: "เลขที่บัญชี",
    bank: "ธนาคาร",
    bankDocument: "เอกสารทางธนาคาร",
    warehouseName: "ชื่อคลังสินค้า",
    uploadLogo: "กรุณาอัพโหลดรูปภาพของคุณ",
    shippingList: "รายชื่อผู้ให้บริการ",
    myShipping: "ผู้ให้บริการที่เลือก",
    searchShipping: "ค้นหาชื่อผู้ให้บริการ",
    invoicePrefix: "คำนำหน้าคำสั่งซื้อ",
    accountStatement: "รายการบัญชีชำระเงิน",
    orderOverview: "รายการคำสั่งซื้อ",
    transactionOverview: "รายการการจ่ายเงิน",
    earning: "รายรับ",
    amtToRecieve: "จำนวนเงินที่ได้รับเป็นบาท (THB)",
    paymentMethod: "บัญชีที่ได้รับเงิน",
    statementStatus: "สถานะการจ่ายเงิน",
    edit: "แก้ไข",
    open: "ยังไม่ได้รับชำระ",
    statementNumber: "เลขที่รายการ",
    statementNo: "เลขที่รายการ",
    orderDate: "วันที่สั่งซื้อสินค้า",
    comission: "คอมมิชชั่น",
    paymentFee: "ค่าธรรมเนียมการชำระเงิน",
    customer: "ลูกค้า",
    shippingCost: "ค่าธรรมเนียมการจัดส่ง",
    promotion: "โปรโมชั่น",
    statementPeriod: "ระยะเวลา",
    payoutStatus: "สถานะการจ่ายเงิน",
    payoutAmt: "ยอดที่ได้รับชำระสุทธิ",
    filterBy: "ค้นหาโดย",
    transactionNo: "เลขที่ธุรกรรม",
    statement: "Statement",
    openBalance: "ยอดขายรวม",
    itemPriceCredit: "ราคาสินค้ารวม",
    affiliateFee: "ค่าธรรมเนียมตัวแทน",
    subTotal: "ยอดรวม (บาท)",
    closeBalance: "ยอดรวมสุทธิ (บาท)",
    paidByCus: "ชำระโดยลูกค้า",
    paidBySeller: "ชำระโดยผู้ขาย",
    paid: "ได้รับเงินแล้ว",
    totalOrder: "ทั้งหมด",
    deliveredOrder: "สำเร็จ",
    deliveredOrderFail: "สินค้าเสียหาย / สูญหาย",
    returnOrder: "ส่งคืน",
    selectCategoryRequired: "กรุณาเลือกหมวดหมู่อย่างน้อย 1 หมวดหมู่",
    required: "กรุณากรอกข้อมูล",
    enterAtLeast: "กรุณากรอกตัวอักษรอย่างต่ำ",
    chars: "ตัวอักษร",
    emailError: "กรุณากรอกอีเมลให้ถูกต้อง (เช่น email@example.com)",
    numOnly: "กรุณากรอกตัวเลขเท่านั้น",
    noMoreThan: "กรุณากรอกตัวอักษรมากสุด",
    passNotMatch: "รหัสผ่านต้องสัมพันธ์กัน",
    charNotMatch: "กรุณากรอกเฉพาะตัวอักษรภาษาอังกฤษเท่านั้น",
    minValueError: "กรุณากรอกตัวเลขมากกว่า ",
    selectImgError: "กรุณาเลือกรูปภาพสำหรับตัวเลือกนี้",
    alreadyPack: "เรียกขนส่ง",
    printCoverPage: "พิมพ์ใบปะหน้า",
    onceTheSelectedItemCoverSheetIsPrinted:
      "เมื่อทำการพิมพ์ใบปะหน้ารายการที่เลือกแล้วจะเป็นการยืนยันและเรียกให้ขนส่งมารับสินค้ารายการที่เลือกไป",
    pleasePrepareTheProduct: "กรุณาเตรียมสินค้าให้พร้อม",
    theDateAndTimeReceivingTheProductDependingOnTheServiceProvider:
      "วันและเวลาของการเข้ามารับสินค้า ขึ้นอยู่กับผู้ให้บริการ",
    close: "ปิด",
    delete: "ลบ",
    doYouWantToDelete: "คุณต้องการลบ",
    yesOrNo: "ใช่หรือไม่",
    confirmDelete: "ยืนยันการลบ",
    article: "รายการบทความ",
    createArticle: "สร้างบทความ",
    articleName: "ชื่อบทความ",
    articleDesc: "คำบรรยาย",
    sortOrder: "ลำดับ",
    urlKey: "URL Key",
    cover: "ภาพหน้าปก",
    displayOnProduct: "สินค้าที่แสดง",
    sold: "ยอดขาย (ชิ้น)",
    createDate: "วันที่สร้าง",
    articleStatus: "สถานะ",
    pleaseUpload: "กรุณาเลือกไฟล์เพื่ออัพโหลด",
    displayOnSelected: "แสดงเฉพาะที่เลือก",
    selectCategory: "เลือกหมวดหมู่สินค้า",
    increase: "เพิ่ม",
    decrease: "ลด",
    adjust: "แก้ไข",
    variation: "ตัวเลือก",
    optionName: "ชื่อตัวเลือก",
    options: "ตัวเลือก",
    createNewOptions: "สร้างตัวเลือก",
    stock: "สต๊อก",
    saveAndPublish: "บันทึกและเผยแพร่",
    saveDraft: "บันทึกแบบร่าง",
    check: "ตรวจสอบ",
    outOfStock: "สินค้าหมด",
    lowStock: "สินค้าใกล้หมด",
    create: "สร้าง",
    importData: "นำเข้าข้อมูล",
    exportData: "ส่งออกข้อมูล",
    downloadTemplate: "ดาวน์โหลดแบบฟอร์มกรอกข้อมูล",
    inOutwards: "เพิ่ม/ลด",
    closingBalance: "คงเหลือ",
    refNo: "เลขที่อ้างอิง",
    unit: "หน่วย",
    combinationList: "รายการตัวเลือกสินค้า",
    answer: "ตอบแล้ว",
    waitForAns: "รอคำตอบ",
    productSelected: "สินค้าที่เลือก",
    add: "เพิ่ม",
    note: "หมายเหตุ",
    stockLog: "รายการสต๊อก",
    defaultImg: "ภาพสินค้า",
    fileNotSupport: "ระบบไม่รองรับไฟล์สกุลนี้",
    fileIsTooLarge: "ไฟล์นี้มีขนาดใหญ่เกินไป",
    supportFile: "รับรองสกุลไฟล์ .jpg, .png และ .pdf เท่านั้น (สูงสุด 50 MB)",
    enterAtLeastOption: "กรุณากรอกข้อมูลอย่างน้อย 1 ตัวเลือก",
    fillThisForm: "กรุณากรอกข้อมูลให้ครบถ้วน",
    view: "ดูตัวอย่าง",
    pleaseWait: "กรุณารอสักครู่",
    action: "ตัวเลือก",
    simpleProduct: "สินค้าทั่วไป",
    configProduct: "สินค้าแบบมีตัวเลือก",
    save: "บันทึก",
    saveAndExit: "บันทึกและออก",
    selectProvince: "กรุณาเลือกจังหวัด",
    selectDistrict: "กรุณาเลือกอำเภอ",
    selectSubDistrict: "กรุณาเลือกตำบล",
    selectBank: "กรุณาเลือกธนาคาร",
    approve: "ยืนยันการคืนสินค้า",
    reject: "ปฏิเสธการคืนสินค้า",
    inprogress: "ขอคืนสินค้า",
    replyRequest: "หมายเหตุสำหรับรายการนี้",
    returnDetails: "รายละเอียดการคืนสินค้า",
    campaign: "แคมเปญ",
    campaignName: "ชื่อแคมเปญ",
    seller: "รหัสผู้ขาย",
    regisCloseIn: "ลงทะเบียนจะปิดใน",
    campaignPeriod: "ระยะเวลาแคมเปญ",
    campaignDetails: "รายละเอียดแคมเปญ",
    currentPrice: "ราคาปัจจุบัน",
    campaignPrice: "ราคาในแคมเปญนี้",
    stockToBuy: "จำนวนสินค้าที่ต้องการขาย",
    salePrice: "ราคาเต็ม",
    bankName: "ชื่อธนาคาร",
    bankAccountNo: "เลขที่บัญชี",
    bankAccountName: "ชื่อบัญชี",
    defaultImgError: "กรุณาเลือกรูปอย่างน้อย 1 รูป",
    currentStock: "จำนวนสต๊อก",
    remainStock: "สต๊อกคงเหลือ",
    omiseTotal: "ค่าธรรมเนียม Omise",
    omiseVat: "ภาษีมูลค่าเพิ่ม (7%)",
    omiseCharge: "ค่าธรรมเนียมรับชำระเงิน (3.65%)",
    requestApprove: "ส่งคำขอยืนยัน",
    shippingSubsidize: "การอุดหนุนค่าขนส่ง",
    attention: "โปรดทราบ",
    noteFromAdmin: "ข้อความจากแอดมิน",
    partner: "แบรนด์",
    seller: "ผู้ซื้อ",
    generalSellerAccountError: "กรุณากรอกข้อมูลบัญชีคู่ค้า",
    generalBusinessProfileError: "กรุณากรอกข้อมูลธุรกิจ",
    generalBankAccountError: "กรุณากรอกข้อมูลบัญชีธนาคาร",
    generalWarehouseAddressError: "กรุณากรอกข้อมูลืั้อยู่คลังสินค้า",
    invoiceError: "กรุณากรอกข้อมูลเลขที่คำสั่งซื้อ",
    logoError: "กรุณาใส่รูปของคู่ค้า",
    shippingError: "กรุณากรอกขนส่งที่รองรับ",
    oldToNew: "เก่าสุด - ล่าสุด",
    newToOld: "ล่าสุด - เก่าสุด",
    warningLogs:
      "ขณะนี้บัญชีของท่านยังไม่ได้รับการยืนยันจากเจ้าหน้าที่ ทำให้ท่านจะไม่สามารถถอนเงินได้ โปรดรอการตรวจสอบเพื่อยืนยันโดยใช้เวลา 1-3 วันทำการ ขออภัยในความไม่สะดวก หากมีข้อสงสัยติดต่อเจ้าหน้าที่ภายในวันและเวลาทำการ",
    day: "วัน",
    addProductToCampaign: "เลือกสินค้าใส่แคมเปญ",
    sold: "ขายแล้ว",
    outOfStock: "สินค้าหมด",
    waitForPay: "รอการชำระเงิน",
    waitForShip: "รอการขนส่ง",
    waitForConfirm: "รอการยืนยัน",
    returnRequest: "คำขอคืนสินค้า",
    codReject: "รายการปฏิเสธเก็บเงินปลายทาง",
    revenue: "รายได้",
    view: "เข้าชม",
    avgOrder: "ค่าเฉลี่ยการสั่งซื้อ",
    upcomingCampaign: "แคมเปญที่กำลังจะมาถึง",
    sellerDb: "ร้านค้า",
    openDb: "เข้า",
    returnProduct: "สินค้าที่คืนแล้ว",
    selectOrderError: "กรุณาเลือกรายการสั่งซื้อ",
    avaliableCampaign: "แคมเปญที่เข้าร่วมได้",
    registeredCampaign: "แคมเปญที่เข้าร่วมแล้ว",
    join: "เข้าร่วม",
    basicInfo: "ข้อมูลแคมเปญ",
    registrationEnd: "หมดเวลาเข้าร่วมใน",
    joinNow: "เข้าร่วมตอนนี้",
    sellerJoined: "ผู้ขายที่เข้าร่วมแคมเปญนี้",
    notJoin: "ยังไม่เข้าร่วมกับแคมเปญนี้",
    productCount: "ชิ้น",
    start: "เริ่ม",
    end: "สิ้นสุด",
    display: "แสดงผล",
    notdisplay: "ไม่แสดงผล",
    productPrice: "ราคาขาย",
    noCampaign: "ยังไม่มีแคมเปญในขณะนี้",
    joined: "เข้าร่วมแล้ว",
    gpFee: "ค่าธรรมเนียม GP (VAT 7%)",
    grandtotalWithoutGP: "ยอดคงเหลือของยอดขายรวมหลังหัก GP",
    omiseFee: "ค่าธรรมเนียม Omise",
    noDataCategory: "ไม่พบข้อมูล",
    location: "สถานที่",
    seeBookBank: "ดูรายละเอียดบัญชีธนาคาร",
    sendMsg: "ส่งข้อความ",
    noMoreThanPrice: "ราคาในแคมเปญนี้ต้องไม่เกินส่วนลดขั้นต่ำ ",
    totalOrder: "ยอดขายรวม",
    gpOrder: "ค่าธรรมเนียม GP",
    vatGp: "VAT 7% (ของ GP) ",
    totalWithGp: "ราคาทุน",
    shippingOrder: "ค่าจัดส่ง",
    hello: "สวัสดี! มีอะไรให้เราช่วยได้ไหม?",
    dbProductOverview: "ภาพรวมสินค้า",
    dbRevenueProduct: "รายได้สินค้าทั้งหมด",
    dbPerformance: "ภาพรวมของเว็บ",
    dbCampaign: "แคมเปญ",
    dbProductPerformance: "ภาพรวมของสินค้าทั้งหมด",
    resendOrder: "รีเซนออเดอร์",
    todayPerformance: "ภาพรวมวันนี้",
    dbTotalSale: "ยอดขาย",
    dbTotalOrder: "จำนวนรายการสั่งซื้อ",
    dbTotalPerClick: "อัตราการซื้อต่อการเข้าชม",
    dbTotalSalePerCustomer: "ยอดขายต่อผู้ซื้อ",
    dbOverview: "ยอดเข้าชม",
    week: "สัปดาห์",
    month: "เดือน",
    year: "ปี",
    dbCustomerDetails: "รายละเอียดลูกค้า",
    male: "ชาย",
    female: "หญิง",
    genderOther: "N/A",
    dbCusByProvince: "กลุ่มลูกค้าแบ่งตามจังหวัด",
    provinceName: "ชื่อจังหวัด",
    topTenBestSellerBaht: "10 อันดับสินค้าขายดี (บาท)",
    topTenBestSellerUnit: "10 อันดับสินค้าขายดี (จำนวน)",
    topTenProfit: "10 อันดับรายได้ (บาท)",
    topTenShare: "10 อันดับสินค้าที่แชร์มากที่สุด",
    resend: "ส่งอีกครั้ง",
    sent: "จัดส่งใหม่แล้ว",
    shareCount: "จำนวนแชร์",
    clickCount: "จำนวนคลิกดู",
    conversion: "Conversion",
    viewCount: "จำนวนเข้าชม",
    cashBack: "เงินคืน",
    fee: "ค่าธรรมเนียม",
    totalShare: "จำนวนครั้งที่แชร์ (สินค้า/บทความ)",
    totalJoinCampaign: "จำนวนแคมเปญที่เข้าร่วม",
    totalShareProduct: "จำนวนครั้งที่แชร์ (สินค้า/บทความ)",
    totalOrderDb: "จำนวนครั้งที่เกิดยอดซื้อ",
    totalProductJoinCampaign: "จำนวนสินค้าที่เข้าร่วมแคมเปญ",
    totalProduct: "จำนวนชิ้นที่ขายได้ (ชิ้น)",
    totalProductShare: "จำนวนสินค้าที่แชร์",
    totalProductChannel: "Channel ที่สร้างยอดขายมากสุด (อิงจำนวนชิ้น)",
    totalChashback: "จำนวนเงินคืน",
    revenuePorductChanel: "Channel ที่สร้างยอดขายมากสุด (อิงยอดขาย)",
    productListDb: "สินค้าทั้งหมด",
    campaignListDb: "แคมเปญทั้งหมด",
    revenueCampaign: "ยอดจากการเข้าร่วมแคมเปญ",
    totalOrderCampaign: "จำนวนคำสั่งซื้อสินค้าแคมเปญ",
    top1: "อันดับ 1",
    top2: "อันดับ 2",
    top3: "อันดับ 3",
    bannerName: "ชื่อแบนเนอร์",
    exLink: "ลิ้งค์ไปยังภายนอก",
    bannerImgDesktop: "ภาพแบนเนอร์สำหรับคอมพิวเตอร์",
    bannerImgMobile: "ภาพแบนเนอร์สำหรับมือถือ",
    returned: "คืนสำเร็จ",
    textValidatePassword:
      "รหัสผ่านจะต้องประกอบด้วยตัวอักษร a-z และ 1-9 ควรมีความยาวไม่ต่ำกว่า 6 ตัวอักษร",
    noQuestion: "ไม่พบคำถาม",
    welcome: "ยินดีต้อนรับเข้าสู่ระบบ Brand Center",
    login: "เข้าสู่ระบบ",
    password: "รหัสผ่าน",
    conpassword: "ยืนยันรหัสผ่าน",
    forgetPass: "ลืมรหัสผ่าน",
    resetPass: "ตั้งรหัสผ่านใหม่",
    thisLinkAlreadyUsed: "ลิ้งค์นี้เคยถูกใช้ไปแล้ว",
    becomePartner: "สมัครแบรนด์กับเรา",
    requestOtp: "ขอรหัส OTP",
    receiveOtp: "คุณจะรับรหัส OTP ภายใน 3 นาที",
    shopName: "ชื่อแบรนด์",
    iaccept: "ฉันยอมรับ",
    termandcon: "ข้อตกลงและเงื่อนไขการใช้งาน",
    and: "และ",
    privacy: "นโยบายความเป็นส่วนตัว",
    submit: "ยืนยัน",
    alreadyHasAcc: "มีบัญชีอยู่แล้ว",
    waitApprove:
      "ขณะนี้บัญชีของท่านอยู่ระหว่างรอการยืนยันจากเจ้าหน้าที่ โดยใช้เวลาในการดำเนินการ 1-2 วัน โดยท่านสามารถสร้างสินค้า ได้ตามปกติ แต่สินค้าของท่านจะไม่สามารถขายได้ จนกว่าจะได้รับการยืนยันบัญชีจากเจ้าหน้าที่",
    above: "ขึ้นไป",
    all: "ทั้งหมด",
    changeTelephoneNumber: "เปลี่ยนเบอร์โทรศัพท์",
    youCanResendIn: "สามารถส่งอีกครั้งได้ใน",
    submitOtp: "ยืนยัน OTP",
    enterOTP: "ระบุ OTP ที่ได้รับ",
    referenceCode: "รหัสอ้างอิง",
    dashboard: "ภาพรวม",
    omiseWithdraw: "ค่าธรรมเนียมถอนเงิน",
    paidByPartner: "ชำระโดยแบรนด์",
    bookBank: "รูปบัญชีธนาคาร",
    subTotalOrder: "ยอดรวม (รวม VAT)",
    shippingDetails: "ข้อมูลการจัดส่ง",
    trackNo: "หมายเลขติดตามพัสดุ",
    sentby: "จัดส่งโดย",
    shippingStatus: "สถานะการจัดส่ง",
    nofaq: "ไม่พบคำถาม กรุณาติดต่อเจ้าหน้าที่",
    telError: "กรุณากรอกเบอร์โทรศัพท์",
    otpError: "รหัส OTP ไม่ถูกต้อง กรุณากรอกใหม่",
    requestOtp: "ขอรหัส OTP",
    bannerImgRequire:
      "กรุณาอัพโหลดไฟล์สกุล .png, .jpg ขนาด 16:9 หรือ .mp4 ขนาดไม่เกิน 50 MB",
    bannerImgRequire1_1:
      "กรุณาอัพโหลดไฟล์สกุล .png, .jpg ขนาด 1:1 หรือ .mp4 ขนาดไม่เกิน 50 MB",
    bannerImgRequire4_3:
      "กรุณาอัพโหลดไฟล์สกุล .png, .jpg ขนาด 4:3 หรือ .mp4 ขนาดไม่เกิน 50 MB",
    bannerImgRequire10_2:
      "กรุณาอัพโหลดไฟล์สกุล .png, .jpg ขนาด 10:2 หรือ .mp4 ขนาดไม่เกิน 50 MB",
    bannerImgRequire10_4:
      "กรุณาอัพโหลดไฟล์สกุล .png, .jpg ขนาด 10:4 หรือ .mp4 ขนาดไม่เกิน 50 MB",
    feedImgRequire:
      "กรุณาอัพโหลดไฟล์สกุล .png, .jpg ขนาด 4:3 ขนาดไม่เกิน 10 MB",
    withdraw: "ถอนเงิน",
    withdrawreq: "คุณต้องการที่จะถอนเงิน",
    from: " เพื่อเข้าบัญชี ",
    withdrawreq2: "หรือไม่?",
    confirmWithdraw: "ยืนยันถอนเงิน",
    serviceGp: "ค่าบริการ",
    costCod: "ค่าบริการเก็บเงินปลายทาง",
    creditFee: "ค่าธรรมเนียมบัตรเดบิต/เครดิต 3.6%",
    withdrawFee: "ค่าธรรมเนียมถอนเงินผ่านธนาคาร 2% (ขั้นต่ำ ฿ 30)",
    otherFee: "ค่าธรรมเนียมอื่นๆ",
    addLinePartner: "กรุณาเพิ่มเพื่อน เพื่อติดต่อทีมดูแล Brand ได้ที่",
    orClick: "หรือคลิ้กที่",
    importprodata: "นำเข้าข้อมูลสินค้า",
    exportprodata: "ส่งออกข้อมูลสินค้า",
    loadtemplate: "ดาวน์โหลด Template",
    importfile: "ไฟล์",
    import: "นำเข้า",
    excelOnly: "*กรุณาอัพโหลดไฟล์สกุล .xlsx ขนาดไม่เกิน 10 MB",
    ofRawPrice: "ของราคาสินค้า",
    minProductGP: "ค่า GP ขั้นต่ำ",
    outstandingBalance: "จำนวนเงินที่ค้างชำระ",
    anonymousReturn: "คำขอคืนสินค้าโดยไม่ระบุชื่อ",
    chooseFile: "เลือกไฟล์",
    totalSales: "ยอดขายรวม",
    totalDiscount: "ส่วนลดรวม",
    salesAfterDiscount: "ยอดขายหลังหักส่วนลด",
    expenses: "ค่าใช้จ่าย",
    salesFee: "ค่าธรรมเนียมการขายของ Seller",
    salesFeeThroughSystem: "ค่าธรรมเนียมการขายผ่านระบบ Brand",
    paymentFees: "ค่าธรรมเนียมการชำระเงิน",
    shippingAndCODFees: "ค่าธรรมเนียมขนส่งและค่าบริการเก็บเงินปลายทาง",
    shippingFees: "ค่าธรรมเนียมขนส่ง",
    CODFees: "ค่าบริการเก็บเงินปลายทาง",
    netIncome: "รายได้สุทธิ",
    downloadInvoice: "ดาวน์โหลดใบแจ้งหนี้",
    waitingForPayment: "รอการชำระเงิน",
    withdrawalAndTransferFees: "ค่าธรรมเนียมการถอนและโอนเงิน",
    seeMore: "ดูเพิ่มเติม",
    showOrderDetails: "แสดงรายละเอียดรายการสั่งซื้อ",
    viewInvoiceDetails: "ดูรายละเอียดใบแจ้งหนี้",
    invoice: "ใบแจ้งหนี้",
    downloadDoc: "ดาวน์โหลดเอกสาร",
    amountOverdue: "จำนวนที่ค้างชำระ",
    downloadTaxInvoice: "ดาวน์โหลดใบกำกับภาษี",
    downloadList: "ดาวน์โหลดรายการ",
    withholdingTax: "หัก ณ ที่จ่าย",
    getfinService: "ค่าบริการ Brand",
    paymentTransactionFee: "ค่าธุรกรรมการชำระเงิน",
    totalService: "ค่าใช้จ่ายรวม",
    totalServiceVat: "ค่าใช้จ่ายรวม (รวมภาษีมูลค่าเพิ่ม)",
    totalSalesFee: "ค่าธรรมเนียมการขายรวม (GP)",
    waitingOrderComplete: "รอคำสั่งซื้อสมบูรณ์",
    homePage: "หน้าหลัก",
    campaignInfo: "ข้อมูลแคมเปญ",
    campaignProductList: "รายการสินค้าของแคมเปญ",
    orderDetails: "รายละเอียดคำสั่งซื้อ",
    resendOrderDetails: "รายละเอียดรีเซนออเดอร์",
    returnOverview: "รายการคืนสินค้า",
    articleList: "รายการบทความ",
    articleDetails: "รายละเอียดบทความ",
    FAQList: "รายการคำถามที่พบบ่อย",
    bannerDetails: "รายละเอียดแบนเนอร์",
    bannerPromotionList: "รายการโปรโมชั่น",
    bannerPromotionDetails: "รายละเอียดโปรโมชั่น",
    Page404: "404",
    page500: "500",
    VATIncluded: "รวมภาษีมูลค่าเพิ่ม",
    VATNotIncluded: "ไม่รวมภาษีมูลค่าเพิ่ม",
    netAmount: "ยอดสุทธิ",
    incomeAfterDiscount: "รายได้หลังหักส่วนลด",
    textValidateUrlkey:
      "URL Key ประกอบไปด้วยตัวอักษร ก-ฮ, a-z, 1-9 หรืออักขระพิเศษ - และ _ เท่านั้น",
    productPriceError: "ต้องมีค่ามากกว่า",
    maxSalestockError: "จำนวนสินค้าที่ต้องการขายต้องน้อยกว่าหรือเท่ากับสต๊อก",
    TotalAfterDeductionExpenses: "ยอดรวมหลังหักค่าใช้จ่าย",
    transferAmount: "ยอดเงินโอน",
    platformAdministrationFee: "ค่าบริหารแพลตฟอร์ม",
    consentProductToLive: "ยินยอมให้นำสินค้าไป Live",
    agree: "ยินยอม",
    doNotAgree: "ไม่ยินยอม",
    textClickConfirmAgree:
      'การกด "ยืนยัน" ถือเป็นการยอมรับเงื่อนไขการใช้งานตามนโยบายการใช้งาน',
    limitChangeGP: "ท่านได้ทำการเปลี่ยน GP เกินจำนวนครั้งที่กำหนดแล้ว",
    pleaseSelect: "กรุณาเลือก",
    aboutStore: "เกี่ยวกับร้านค้า",
    storeDesc: "คำบรรยายร้านค้า (Bio)",
    gpWarningText:
      "หมายเหตุ : สามารถแก้ไข GP ได้เดือนละ 1 ครั้ง และ GP ใหม่ที่เปลี่ยนแปลง จะมีผลทุกๆวันที่ 1 ของเดือนถัดไปเท่านั้น",
    editProductGP: "แก้ไข GP ของสินค้า",
    cancelGP: "ยกเลิก",
    submitGP: "ตกลง",
    legalEntity: "นิติบุคคล",
    sellerGetfinFee: "ค่า Seller Brand",
    loading: "กำลังโหลด",
    downloadSellerFeeInvoice: "ดาวน์โหลดใบกำกับภาษีค่าธรรมเนียมของ Seller",
    downloadInvoiceOther: "ดาวน์โหลดใบกำกับภาษีค่าใช้จ่ายอื่นๆ",
    descUrlKey:
      "URL Key สามารถแก้ไขได้โดยจะต้องเป็นภาษาอังกฤษและห้ามมีช่องว่าง",
    textSystemMaintenance1: "ขออภัยในความไม่สะดวก",
    textSystemMaintenance2: "Brand ขอแจ้งปิดปรับปรุงเว็บไซต์ชั่วคราว",
    textSystemMaintenance3: "เพื่อพัฒนาระบบและเพิ่มประสิทธิภาพให้ดียิ่งขึ้น",
    textSystemMaintenanceOnDate: "ในวันที่",
    textSystemMaintenanceOnTime1: "เวลา",
    textSystemMaintenanceOnTime2: "น.",

    lastStatus: "สถานะล่าสุด",
    detailsRequest: "รายละเอียดประกอบคำขอ",
    detailAddress: "รายละเอียดการจัดส่ง",
    detailReceipt: "รายละเอียดใบเสร็จ",
    moneyTransferDetails: "รายละเอียดการโอนเงิน",
    imgReturnIlustration: "รูปประกอบการคืน",
    saveReplyRequest: "บันทึกเพิ่มเติมสำหรับคำขอนี้",
    date: "วัน",
    time: "เวลา",
    returnApproval: "ยืนยันการคืน",
    refuseReturn: "ปฏิเสธการคืน",
    returnDetails: "รายละเอียดการส่งคืน",
    returnIllustration: "รูปประกอบการคืน",
    transport: "ขนส่งที่เลือกส่งคืน",
    tracking: "เลขติดตามพัสดุ",
    bankAccount: "บัญชีธนาคารรับเงิน",
    bankAccountNumber: "เลขบัญชีธนาคาร",
    bankAccountName: "ชื่อบัญชีรับเงิน",
    proofOfTransfer: "หลักฐานการโอนคืน",
    viewDetail: "ดูรายละเอียด",
    download: "ดาวน์โหลด",
    transferAmount: "จำนวนเงินที่โอน",
    lastUpdate: "อัพเดทล่าสุด",
    confirmation: "ยืนยันการรับคืนสินค้า",
    areYouSureYouWantToConfirmReceiptOfTheProduct:
      "คุณแน่ใจหรือไม่ว่าต้องการยืนยันการได้รับสินค้า",
    viewDetailsOfProofOfTransfer: "ดูรายละเอียดหลักฐานการโอน",
    paymentInfo: "ข้อมูลการชำระเงิน",
    warningImportProduct: "กรุณาตรวจสอบไฟล์ก่อนทำการอัพโหลดสินค้า",
    msgAlertComfirmReturn:
      "กรุณาตรวจสอบสินค้าที่ได้รับคืนมาจากการส่งของผู้ซื้อ ว่าสินค้าไม่ได้รับการใช้งานการเสียหายจากการขนส่ง หรือ การเสียหายจากการใช้งาน หากตรวจสอบเรียบร้อยแล้วต้อง การยืนยันการคืนสินค้า สามารถดำเนินการโอนเงินไปยังผู้ซื้อได้ทันที",
    msgComfirmReturn: "คุณแน่ใจหรือไม่ว่าต้องการยืนยันการได้รับสินค้า",
    msgConfirmReceiptReturn: "ยืนยันการได้รับสินค้า",
    msgAlertComfirmRejectReturn:
      "เมื่อคุณปฎิเสธการรับสินค้าคืนแล้วจะถือเป็นการสิ้นสุดกระบวนการคืนสินค้าของระบบ คุณจะต้องดำเนินการติดตามการชดใช้จากผู้ซื้อด้วยตนเองเท้านั้น คุณต้องการปฎิเสธการรับสินค้า ที่ได้รับการส่งคืนจากผู้ซื้อ ด้วยเหตุผลใดโปรดระบุ",
    msgComfirmRejectReturn: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธการรับสินค้า",
    msgConfirmReceiptRejectReturn: "ยืนยันการปฏิเสธการรับ",
    requireTinyUploadImg: "กรุณาอัพโหลดไฟล์ขนาดไม่เกิน 5 MB",
    uploadFail: "อัพโหลดไม่สำเร็จ",
    transferMoney: "แจ้งโอนเงินคืน",
    ourPartner: "แบรนด์ของเรา",
    findPartner: "ค้นหาแบรนด์",
    partnerNotFound: "ไม่พบแบรนด์",
    additionalCostFromTransportation: "ค่าใช้จ่ายเพิ่มเติมจากการขนส่ง",

    shippingTypeName: "ช่องทางการจัดส่ง",
    ShippingType: "ประเภทการจัดส่ง",
    BuyingMethod: "ช่องทางการสั่งซื้อ",
    importTrackingFile: "นำเข้าเลขติดตามพัสดุ",
    ExportOrder: "นำออกรายการคำสั่งซื้อ",
    downloadTemplate1: "ดาวน์โหลดเทมเพลต",
    uploadTrackingFile: "อัพโหลดเลขติดตามพัสดุ",

    chooseShippingName: "เลือกขนส่งที่อัพโหลด",
    selectShippingName: "กรุณาเลือกขนส่ง",
    discountFromGetfin: "ส่วนลดจาก Brand",
    discountFromSeller: "ส่วนลดจากนักขายออนไลน์",

    updateShipping: "อัพเดตข้อมูลจัดส่ง",
    moreDetail: "ดูรายละเอียดการขนส่ง",

    noteForOwnfleet:
      "สำหรับการจัดส่งโดยแบรนด์ ทางแบรนด์จะต้องเป็นผู้รับผิดชอบค่าขนส่งทั้งหมดทุกกรณี",
    headerOwnShipping: "รองรับการจัดส่งโดยแบรนด์",
    iagree: "ฉันเข้าใจแล้ว",
  },
};

Vue.use(VueI18n);
Vue.use(VueCookies);

let language = VueCookies.get("language") || "en";

export const i18n = new VueI18n({
  locale: language, // set locale
  fallbackLocale: language,
  messages, // set locale messages
});
